exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".highlighted-result {\n  color: #657787;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  row-gap: 0.4rem;\n}\n.highlighted-result + .highlighted-result {\n  margin-top: 1rem;\n}\n.highlighted-result .highlighted-result__title {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #000;\n}\n.highlighted-result .highlighted-result__content {\n  font-size: 1.3rem;\n}", ""]);

// exports
